export default __webpack_public_path__ + "static/media/AppMicH.7033dbca.png";